// import React, { useState, useEffect } from "react";
// import { Card, Table, Input, Button, Space, Tag, Tooltip, Select } from "antd";
// import {
//   EyeOutlined,
//   EditOutlined,
//   DeleteOutlined,
//   PoweroffOutlined,
// } from "@ant-design/icons";
// import Modal from "../../components/Modal";
// import { useGet, usePost, useDynamicApi } from "../../hooks/useApi";
// import { useDebounce } from "../../hooks/useDebounce";
// import { API_ENDPOINTS } from "../../config/api";
// import Toast from "../../utils/toast";
// import { useNavigate } from "react-router-dom";
// import { useTranslation } from "react-i18next";

// const SubscriptionPriceManager = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
//   const [selectedPackage, setSelectedPackage] = useState(null);
//   const [packageToDelete, setPackageToDelete] = useState(null);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [submitting, setSubmitting] = useState(false);

//   // State for form data
//   const [formData, setFormData] = useState({
//     name: "",
//     package_type: "INDIVIDUAL",
//     duration: "SEASONAL",
//     base_price: "",
//     discounted_price: "",
//     currency: "EUR",
//     effective_start: "",
//     effective_end: "",
//     is_active: true,
//   });

//   // Form validation errors
//   const [formErrors, setFormErrors] = useState({});

//   // Pagination, search and filter states
//   const [searchTerm, setSearchTerm] = useState("");
//   const [packageTypeFilter, setPackageTypeFilter] = useState("");
//   const [durationFilter, setDurationFilter] = useState("");
//   const [statusFilter, setStatusFilter] = useState("");
//   const debouncedSearchTerm = useDebounce(searchTerm, 500);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCount, setTotalCount] = useState(0);
//   const [packageList, setPackageList] = useState([]);

//   // Options as per FRS and your model
//   const PACKAGE_TYPE_OPTIONS = [
//     { value: "INDIVIDUAL", label: t("priceManager.packageTypeIndividual") },
//     { value: "CLUB", label: t("priceManager.packageTypeClub") },
//     { value: "KNKV", label: t("priceManager.packageTypeKNKV") },
//   ];

//   const DURATION_OPTIONS = [
//     { value: "MONTHLY", label: t("priceManager.durationMonthly") },
//     { value: "QUARTERLY", label: t("priceManager.durationQuarterly") },
//     { value: "YEARLY", label: t("priceManager.durationYearly") },
//     { value: "SEASONAL", label: t("priceManager.durationSeasonal") },
//   ];

//   const CURRENCY_OPTIONS = [
//     { value: "EUR", label: t("priceManager.currencyEUR") },
//     { value: "USD", label: t("priceManager.currencyUSD") },
//     { value: "INR", label: t("priceManager.currencyINR") },
//   ];

//   // Status filter options
//   const STATUS_OPTIONS = [
//     { value: "active", label: t("common.active") },
//     { value: "inactive", label: t("common.inactive") },
//   ];

//   // API hooks - Fixed filter params
//   const {
//     execute: fetchList,
//     error: fetchError,
//     loading: loadingList,
//   } = useGet(
//     `${API_ENDPOINTS.PRICE_SUBSCRIPTION_LIST}?page=${currentPage}&page_size=${pageSize}&search=${debouncedSearchTerm}&package_type=${packageTypeFilter || ""}&duration=${durationFilter || ""}&status=${statusFilter || ""}`,
//   );
//   const {
//     post,
//     error: postError,
//     loading: creating,
//   } = usePost(API_ENDPOINTS.PRICE_SUBSCRIPTION_LIST);
//   const {
//     execute: getById,
//     error: getByIdError,
//     loading: loadingById,
//   } = useDynamicApi("GET");
//   const {
//     execute: putData,
//     error: putError,
//     loading: updating,
//   } = useDynamicApi("PUT");
//   const {
//     execute: patchData,
//     error: patchError,
//     loading: updatingStatus,
//   } = useDynamicApi("PATCH");
//   const {
//     execute: deleteData,
//     error: deleteError,
//     loading: deleting,
//   } = useDynamicApi("DELETE");

//   // Loading state
//   const loading =
//     loadingList ||
//     loadingById ||
//     updating ||
//     updatingStatus ||
//     deleting ||
//     submitting;

//   // Load data with current pagination, search and filters
//   const loadData = async () => {
//     try {
//       const response = await fetchList();
//       if (response) {
//         setPackageList(response.data || []);
//         setTotalPages(response.pagination?.total_pages || 1);
//         setTotalCount(response.pagination?.total_count || 0);
//       }
//     } catch (error) {
//       console.error("Error loading data:", error);
//     }
//   };

//   // Initial data fetch
//   useEffect(() => {
//     loadData();
//   }, [currentPage, pageSize]);

//   // Handle search and filters
//   useEffect(() => {
//     setCurrentPage(1);
//     loadData();
//   }, [debouncedSearchTerm, packageTypeFilter, durationFilter, statusFilter]);

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));

//     // Clear error when user starts typing
//     if (formErrors[name]) {
//       setFormErrors((prev) => {
//         const newErrors = { ...prev };
//         delete newErrors[name];
//         return newErrors;
//       });
//     }
//   };

//   const handleNumberInput = (e) => {
//     const { name, value } = e.target;
//     // Allow only numbers and decimal
//     if (value === "" || /^\d*\.?\d*$/.test(value)) {
//       setFormData((prev) => ({
//         ...prev,
//         [name]: value,
//       }));

//       // Clear error when user starts typing
//       if (formErrors[name]) {
//         setFormErrors((prev) => {
//           const newErrors = { ...prev };
//           delete newErrors[name];
//           return newErrors;
//         });
//       }
//     }
//   };

//   // Reset form data
//   const resetForm = () => {
//     setFormData({
//       name: "",
//       package_type: "INDIVIDUAL",
//       duration: "SEASONAL",
//       base_price: "",
//       discounted_price: "",
//       currency: "EUR",
//       effective_start: "",
//       effective_end: "",
//       is_active: true,
//     });
//     setFormErrors({});
//     setSelectedPackage(null);
//     setIsEditMode(false);
//   };

//   // Reset all filters
//   const resetFilters = () => {
//     setSearchTerm("");
//     setPackageTypeFilter("");
//     setDurationFilter("");
//     setStatusFilter("");
//   };

//   // Validate form function - Only sets errors, no toast
//   const validateForm = () => {
//     const errors = {};

//     // Package name validation
//     if (!formData.name.trim()) {
//       errors.name = t("priceManager.nameRequired");
//     } else if (formData.name.trim().length < 2) {
//       errors.name = t("priceManager.nameMinLength");
//     } else if (formData.name.trim().length > 100) {
//       errors.name = t("priceManager.nameMaxLength");
//     }

//     // Base price validation
//     if (!formData.base_price.trim()) {
//       errors.base_price = t("priceManager.basePriceRequired");
//     } else {
//       const basePrice = parseFloat(formData.base_price);
//       if (isNaN(basePrice) || basePrice <= 0) {
//         errors.base_price = t("priceManager.basePricePositive");
//       }
//     }

//     // Discounted price validation
//     if (formData.discounted_price.trim()) {
//       const discountedPrice = parseFloat(formData.discounted_price);
//       const basePrice = parseFloat(formData.base_price);

//       if (isNaN(discountedPrice) || discountedPrice <= 0) {
//         errors.discounted_price = t("priceManager.discountedPricePositive");
//       } else if (discountedPrice > basePrice) {
//         errors.discounted_price = t("priceManager.discountedPriceLessThanBase");
//       }
//     }

//     // Date validation
//     if (formData.effective_start && formData.effective_end) {
//       const startDate = new Date(formData.effective_start);
//       const endDate = new Date(formData.effective_end);

//       if (endDate < startDate) {
//         errors.effective_end = t("priceManager.endDateAfterStart");
//       }
//     }

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // Handle API errors
//   const handleApiError = (error) => {
//     if (error?.response?.data?.errors) {
//       setFormErrors(error.response.data.errors);
//     } else if (error?.response?.data?.message) {
//       Toast.error(error.response.data.message);
//     } else {
//       Toast.error(error?.message || t("common.error"));
//     }
//   };

//   // Handle create subscription package
//   const handleCreate = async (e) => {
//     e?.preventDefault?.();

//     // Only validate, no toast for validation errors
//     if (!validateForm()) {
//       return;
//     }

//     setSubmitting(true);

//     try {
//       const response = await post(formData);

//       if (response?.status === true) {
//         Toast.success(response?.message || t("priceManager.createdSuccess"));
//         await loadData();
//         setIsModalOpen(false);
//         resetForm();
//       } else {
//         if (response?.errors) {
//           setFormErrors(response.errors);
//         } else {
//           Toast.error(response?.message || t("priceManager.failedCreate"));
//         }
//       }
//     } catch (error) {
//       console.error("Error creating subscription package:", error);
//       handleApiError(error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Handle update subscription package
//   const handleUpdate = async (e) => {
//     e?.preventDefault?.();

//     if (!selectedPackage?.id) {
//       Toast.error(t("priceManager.idNotFound"));
//       return;
//     }

//     // Only validate, no toast for validation errors
//     if (!validateForm()) {
//       return;
//     }

//     setSubmitting(true);

//     try {
//       const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${selectedPackage.id}`;
//       const response = await putData(endpoint, formData);

//       if (response?.status === true) {
//         Toast.success(response?.message || t("priceManager.updatedSuccess"));
//         await loadData();
//         setIsModalOpen(false);
//         resetForm();
//       } else {
//         if (response?.errors) {
//           setFormErrors(response.errors);
//         } else {
//           Toast.error(response?.message || t("priceManager.failedUpdate"));
//         }
//       }
//     } catch (error) {
//       console.error("Error updating subscription package:", error);
//       handleApiError(error);
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   // Handle toggle active status
//   const handleToggleActive = async (item) => {
//     try {
//       const newStatus = !item.is_active;
//       const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${item.id}`;

//       const response = await patchData(endpoint, {
//         is_active: newStatus,
//       });

//       if (response?.status === true) {
//         Toast.success(
//           response?.message ||
//             (newStatus ? t("common.active") : t("common.inactive")),
//         );
//         await loadData();
//       } else {
//         Toast.error(response?.message || t("attackManager.failedUpdateStatus"));
//       }
//     } catch (error) {
//       console.error("Error updating status:", error);
//       Toast.error(error.message || t("attackManager.failedUpdateStatus"));
//     }
//   };

//   // Open delete confirmation modal
//   const openDeleteModal = (item) => {
//     setPackageToDelete(item);
//     setIsDeleteModalOpen(true);
//   };

//   // Handle delete confirmation
//   const handleDeleteConfirm = async () => {
//     if (!packageToDelete) return;

//     try {
//       const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${packageToDelete.id}`;
//       const response = await deleteData(endpoint);

//       if (response?.status === true) {
//         Toast.success(response?.message || t("priceManager.deletedSuccess"));
//         await loadData();
//       } else {
//         Toast.error(response?.message || t("priceManager.failedDelete"));
//       }
//     } catch (error) {
//       console.error("Error deleting package:", error);
//       Toast.error(error.message || t("priceManager.failedDelete"));
//     } finally {
//       setIsDeleteModalOpen(false);
//       setPackageToDelete(null);
//     }
//   };

//   // Open modal for create
//   const openCreateModal = () => {
//     resetForm();
//     setIsEditMode(false);
//     setIsModalOpen(true);
//   };

//   // Helper function to fetch package by ID
//   const fetchPackageById = async (id) => {
//     const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${id}`;
//     const response = await getById(endpoint);
//     return response;
//   };

//   // Open modal for edit
//   const openEditModal = async (item) => {
//     try {
//       const response = await fetchPackageById(item.id);

//       if (response?.status === true && response.data) {
//         setSelectedPackage(response.data);
//         setFormData({
//           name: response.data.name || "",
//           package_type: response.data.package_type || "INDIVIDUAL",
//           duration: response.data.duration || "SEASONAL",
//           base_price: response.data.base_price
//             ? response.data.base_price.toString()
//             : "",
//           discounted_price: response.data.discounted_price
//             ? response.data.discounted_price.toString()
//             : "",
//           currency: response.data.currency || "EUR",
//           effective_start: response.data.effective_start || "",
//           effective_end: response.data.effective_end || "",
//           is_active:
//             response.data.is_active !== undefined
//               ? response.data.is_active
//               : true,
//         });
//         setFormErrors({});
//         setIsEditMode(true);
//         setIsModalOpen(true);
//       } else {
//         Toast.error(t("priceManager.failedFetchDetails"));
//       }
//     } catch (error) {
//       console.error("Error fetching package details:", error);
//       Toast.error(error.message || t("priceManager.failedFetchDetails"));
//     }
//   };

//   // Navigate to view page
//   const openViewPage = (id) => {
//     navigate(`/subscription-prices/details/${id}`);
//   };

//   // Format date for display
//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     const date = new Date(dateString);
//     return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
//       year: "numeric",
//       month: "short",
//       day: "numeric",
//     });
//   };

//   // Format currency
//   const formatCurrency = (amount, currency) => {
//     if (!amount || isNaN(amount)) return "N/A";

//     const currencySymbols = {
//       EUR: "€",
//       USD: "$",
//       INR: "₹",
//     };

//     const symbol = currencySymbols[currency] || currency;
//     return `${symbol}${parseFloat(amount).toFixed(2)}`;
//   };

//   // Get package type label
//   const getPackageTypeLabel = (type) => {
//     const option = PACKAGE_TYPE_OPTIONS.find((opt) => opt.value === type);
//     return option ? option.label : type;
//   };

//   // Get duration label
//   const getDurationLabel = (duration) => {
//     const option = DURATION_OPTIONS.find((opt) => opt.value === duration);
//     return option ? option.label : duration;
//   };

//   // Calculate current price
//   const getCurrentPrice = (item) => {
//     if (item.discounted_price) {
//       return item.discounted_price;
//     }
//     return item.base_price;
//   };

//   // Check if price is effective
//   const isPriceEffective = (item) => {
//     if (!item.effective_start && !item.effective_end) {
//       return true;
//     }

//     const today = new Date();
//     const startDate = item.effective_start
//       ? new Date(item.effective_start)
//       : null;
//     const endDate = item.effective_end ? new Date(item.effective_end) : null;

//     if (startDate && today < startDate) return false;
//     if (endDate && today > endDate) return false;

//     return true;
//   };

//   const hasFilters =
//     searchTerm || packageTypeFilter || durationFilter || statusFilter;

//   const columns = [
//     {
//       title: t("priceManager.packageName"),
//       dataIndex: "name",
//       key: "name",
//       render: (name, item) => (
//         <>
//           <strong>{name || "N/A"}</strong>
//           {!isPriceEffective(item) && (
//             <div>
//               <small style={{ color: "orange" }}>
//                 ⏱️ {t("priceManager.pricePending")}
//               </small>
//             </div>
//           )}
//         </>
//       ),
//     },
//     {
//       title: t("priceManager.packageType"),
//       dataIndex: "package_type",
//       key: "package_type",
//       render: (type) => getPackageTypeLabel(type),
//     },
//     {
//       title: t("priceManager.duration"),
//       dataIndex: "duration",
//       key: "duration",
//       render: (duration) => getDurationLabel(duration),
//     },
//     {
//       title: t("priceManager.basePrice"),
//       key: "base_price",
//       render: (_, record) => formatCurrency(record.base_price, record.currency),
//     },
//     {
//       title: t("priceManager.currentPrice"),
//       key: "current_price",
//       render: (_, record) => (
//         <strong style={{ color: "#1890ff" }}>
//           {formatCurrency(getCurrentPrice(record), record.currency)}
//         </strong>
//       ),
//     },
//     {
//       title: t("priceManager.subscriptionDates"),
//       key: "effective",
//       render: (_, record) =>
//         record.effective_start ? (
//           <div>
//             <div>{formatDate(record.effective_start)}</div>
//             <div>
//               {t("common.to")} {formatDate(record.effective_end) || "∞"}
//             </div>
//           </div>
//         ) : (
//           t("priceManager.always")
//         ),
//     },
//     {
//       title: t("common.status"),
//       dataIndex: "is_active",
//       key: "status",
//       render: (active) => (
//         <Tag color={active ? "green" : "default"}>
//           {active ? t("common.active") : t("common.inactive")}
//         </Tag>
//       ),
//     },
//     {
//       title: t("common.actions"),
//       key: "actions",
//       width: 200,
//       render: (_, record) => (
//         <Space>
//           <Tooltip
//             title={record.is_active ? t("common.inactive") : t("common.active")}
//           >
//             <Button
//               className="btn-toggle-active"
//               size="small"
//               danger={record.is_active}
//               type={record.is_active ? "default" : "primary"}
//               icon={<PoweroffOutlined />}
//               onClick={() => handleToggleActive(record)}
//               disabled={updatingStatus}
//             />
//           </Tooltip>
//           <Tooltip title={t("common.view")}>
//             <Button
//               className="btn-view"
//               type="primary"
//               size="small"
//               icon={<EyeOutlined />}
//               onClick={() => openViewPage(record.id)}
//             />
//           </Tooltip>
//           <Tooltip title={t("common.edit")}>
//             <Button
//               className="btn-edit"
//               type="primary"
//               size="small"
//               style={{ background: "#52c41a", borderColor: "#52c41a" }}
//               icon={<EditOutlined />}
//               onClick={() => openEditModal(record)}
//             />
//           </Tooltip>
//           <Tooltip title={t("common.delete")}>
//             <Button
//               className="btn-delete"
//               danger
//               size="small"
//               icon={<DeleteOutlined />}
//               onClick={() => openDeleteModal(record)}
//             />
//           </Tooltip>
//         </Space>
//       ),
//     },
//   ];

//   return (
//     <>
//       <Card
//         title={t("priceManager.title")}
//         extra={
//           <Button type="primary" onClick={openCreateModal} disabled={loading}>
//             {t("priceManager.createNew")}
//           </Button>
//         }
//       >
//         {/* Filters */}
//         <div
//           style={{
//             display: "flex",
//             gap: "16px",
//             marginBottom: 16,
//             flexWrap: "wrap",
//           }}
//         >
//           <Input
//             placeholder={t("priceManager.searchPlaceholder")}
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//             allowClear
//             style={{ width: 280 }}
//             disabled={loading}
//           />
//           <Select
//             placeholder={t("priceManager.packageType")}
//             value={packageTypeFilter || undefined}
//             onChange={(v) => setPackageTypeFilter(v || "")}
//             style={{ width: 160 }}
//             allowClear
//             options={PACKAGE_TYPE_OPTIONS}
//             disabled={loading}
//           />
//           <Select
//             placeholder={t("priceManager.duration")}
//             value={durationFilter || undefined}
//             onChange={(v) => setDurationFilter(v || "")}
//             style={{ width: 160 }}
//             allowClear
//             options={DURATION_OPTIONS}
//             disabled={loading}
//           />
//           <Select
//             placeholder={t("common.filterByStatus")}
//             value={statusFilter || undefined}
//             onChange={(v) => setStatusFilter(v || "")}
//             style={{ width: 140 }}
//             allowClear
//             options={STATUS_OPTIONS}
//             disabled={loading}
//           />
//           {hasFilters && (
//             <Button onClick={resetFilters} disabled={loading}>
//               {t("common.clearFilters")}
//             </Button>
//           )}
//         </div>

//         <div className="table-responsive">
//           <Table
//             dataSource={packageList}
//             columns={columns}
//             rowKey="id"
//             loading={loading}
//             locale={{
//               emptyText: hasFilters
//                 ? t("priceManager.noMatchingPackages")
//                 : t("priceManager.noPricesFound"),
//             }}
//             pagination={{
//               current: currentPage,
//               pageSize,
//               total: totalCount,
//               showSizeChanger: true,
//               pageSizeOptions: ["5", "10", "20", "50", "100"],
//               showTotal: (total) =>
//                 `${t("common.showing")} ${(currentPage - 1) * pageSize + 1} ${t("common.to")} ${Math.min(
//                   currentPage * pageSize,
//                   total,
//                 )} ${t("common.of")} ${total} ${t("priceManager.packages")}`,
//               onChange: (page, size) => {
//                 setCurrentPage(page);
//                 setPageSize(size || 10);
//               },
//             }}
//           />
//         </div>
//       </Card>

//       {/* Create/Edit Modal */}
//       {isModalOpen && (
//         <Modal
//           isOpen={isModalOpen}
//           onClose={() => {
//             setIsModalOpen(false);
//             resetForm();
//           }}
//           title={
//             isEditMode
//               ? t("priceManager.editTitle")
//               : t("priceManager.createTitle")
//           }
//           onConfirm={isEditMode ? handleUpdate : handleCreate}
//           confirmText={
//             isEditMode
//               ? submitting
//                 ? t("priceManager.updating")
//                 : t("common.update")
//               : submitting
//                 ? t("priceManager.creating")
//                 : t("common.create")
//           }
//           showConfirm={true}
//           size="large"
//           confirmDisabled={submitting}
//         >
//           <form onSubmit={isEditMode ? handleUpdate : handleCreate}>
//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "16px",
//                 marginBottom: "16px",
//               }}
//             >
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {t("priceManager.packageName")}{" "}
//                   <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   placeholder={t("priceManager.enterPackageName")}
//                   disabled={submitting}
//                   style={{
//                     width: "100%",
//                     padding: "8px 12px",
//                     border: formErrors.name
//                       ? "1px solid #dc3545"
//                       : "1px solid #d9d9d9",
//                     borderRadius: "4px",
//                   }}
//                   maxLength={100}
//                 />
//                 <div
//                   style={{
//                     fontSize: "12px",
//                     color: "#666",
//                     textAlign: "right",
//                     marginTop: "4px",
//                   }}
//                 >
//                   {formData.name.length}/100
//                 </div>
//                 {formErrors.name && (
//                   <div
//                     style={{
//                       color: "#dc3545",
//                       fontSize: "12px",
//                       marginTop: "4px",
//                     }}
//                   >
//                     {formErrors.name}
//                   </div>
//                 )}
//               </div>

//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {t("priceManager.packageType")}{" "}
//                   <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <select
//                   name="package_type"
//                   value={formData.package_type}
//                   onChange={handleInputChange}
//                   disabled={submitting}
//                   style={{
//                     width: "100%",
//                     padding: "8px 12px",
//                     border: "1px solid #d9d9d9",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   <option value="">
//                     {t("priceManager.selectPackageType")}
//                   </option>
//                   {PACKAGE_TYPE_OPTIONS.map((option) => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "16px",
//                 marginBottom: "16px",
//               }}
//             >
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {t("priceManager.duration")}{" "}
//                   <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <select
//                   name="duration"
//                   value={formData.duration}
//                   onChange={handleInputChange}
//                   disabled={submitting}
//                   style={{
//                     width: "100%",
//                     padding: "8px 12px",
//                     border: "1px solid #d9d9d9",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   <option value="">{t("priceManager.selectDuration")}</option>
//                   {DURATION_OPTIONS.map((option) => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {t("priceManager.currency")}
//                 </label>
//                 <select
//                   name="currency"
//                   value={formData.currency}
//                   onChange={handleInputChange}
//                   disabled={submitting}
//                   style={{
//                     width: "100%",
//                     padding: "8px 12px",
//                     border: "1px solid #d9d9d9",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   {CURRENCY_OPTIONS.map((option) => (
//                     <option key={option.value} value={option.value}>
//                       {option.label}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "16px",
//                 marginBottom: "16px",
//               }}
//             >
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {t("priceManager.basePrice")}{" "}
//                   <span style={{ color: "red" }}>*</span>
//                 </label>
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <span style={{ marginRight: "8px", fontSize: "16px" }}>
//                     {formData.currency === "EUR"
//                       ? "€"
//                       : formData.currency === "USD"
//                         ? "$"
//                         : "₹"}
//                   </span>
//                   <input
//                     type="text"
//                     name="base_price"
//                     value={formData.base_price}
//                     onChange={handleNumberInput}
//                     placeholder="0.00"
//                     disabled={submitting}
//                     style={{
//                       flex: 1,
//                       padding: "8px 12px",
//                       border: formErrors.base_price
//                         ? "1px solid #dc3545"
//                         : "1px solid #d9d9d9",
//                       borderRadius: "4px",
//                     }}
//                   />
//                 </div>
//                 {formErrors.base_price && (
//                   <div
//                     style={{
//                       color: "#dc3545",
//                       fontSize: "12px",
//                       marginTop: "4px",
//                     }}
//                   >
//                     {formErrors.base_price}
//                   </div>
//                 )}
//               </div>

//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {t("priceManager.discountedPrice")}
//                 </label>
//                 <div style={{ display: "flex", alignItems: "center" }}>
//                   <span style={{ marginRight: "8px", fontSize: "16px" }}>
//                     {formData.currency === "EUR"
//                       ? "€"
//                       : formData.currency === "USD"
//                         ? "$"
//                         : "₹"}
//                   </span>
//                   <input
//                     type="text"
//                     name="discounted_price"
//                     value={formData.discounted_price}
//                     onChange={handleNumberInput}
//                     placeholder="0.00"
//                     disabled={submitting}
//                     style={{
//                       flex: 1,
//                       padding: "8px 12px",
//                       border: formErrors.discounted_price
//                         ? "1px solid #dc3545"
//                         : "1px solid #d9d9d9",
//                       borderRadius: "4px",
//                     }}
//                   />
//                 </div>
//                 {formErrors.discounted_price && (
//                   <div
//                     style={{
//                       color: "#dc3545",
//                       fontSize: "12px",
//                       marginTop: "4px",
//                     }}
//                   >
//                     {formErrors.discounted_price}
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div
//               style={{
//                 display: "grid",
//                 gridTemplateColumns: "1fr 1fr",
//                 gap: "16px",
//                 marginBottom: "16px",
//               }}
//             >
//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {t("priceManager.effectiveStart")}
//                 </label>
//                 <input
//                   type="date"
//                   name="effective_start"
//                   value={formData.effective_start}
//                   onChange={handleInputChange}
//                   disabled={submitting}
//                   style={{
//                     width: "100%",
//                     padding: "8px 12px",
//                     border: formErrors.effective_start
//                       ? "1px solid #dc3545"
//                       : "1px solid #d9d9d9",
//                     borderRadius: "4px",
//                   }}
//                 />
//                 {formErrors.effective_start && (
//                   <div
//                     style={{
//                       color: "#dc3545",
//                       fontSize: "12px",
//                       marginTop: "4px",
//                     }}
//                   >
//                     {formErrors.effective_start}
//                   </div>
//                 )}
//               </div>

//               <div>
//                 <label
//                   style={{
//                     display: "block",
//                     marginBottom: "8px",
//                     fontWeight: "500",
//                   }}
//                 >
//                   {t("priceManager.effectiveEnd")}
//                 </label>
//                 <input
//                   type="date"
//                   name="effective_end"
//                   value={formData.effective_end}
//                   onChange={handleInputChange}
//                   disabled={submitting}
//                   style={{
//                     width: "100%",
//                     padding: "8px 12px",
//                     border: formErrors.effective_end
//                       ? "1px solid #dc3545"
//                       : "1px solid #d9d9d9",
//                     borderRadius: "4px",
//                   }}
//                 />
//                 {formErrors.effective_end && (
//                   <div
//                     style={{
//                       color: "#dc3545",
//                       fontSize: "12px",
//                       marginTop: "4px",
//                     }}
//                   >
//                     {formErrors.effective_end}
//                   </div>
//                 )}
//               </div>
//             </div>

//             <div style={{ marginBottom: "16px" }}>
//               <label
//                 style={{ display: "flex", alignItems: "center", gap: "8px" }}
//               >
//                 <input
//                   type="checkbox"
//                   name="is_active"
//                   checked={formData.is_active}
//                   onChange={handleInputChange}
//                   disabled={submitting}
//                 />
//                 <span style={{ fontWeight: "500" }}>
//                   {t("priceManager.activePackage")}
//                 </span>
//               </label>
//             </div>
//           </form>
//         </Modal>
//       )}

//       {/* Delete Confirmation Modal */}
//       {isDeleteModalOpen && packageToDelete && (
//         <Modal
//           isOpen={isDeleteModalOpen}
//           onClose={() => {
//             setIsDeleteModalOpen(false);
//             setPackageToDelete(null);
//           }}
//           title={t("priceManager.confirmDelete")}
//           onConfirm={handleDeleteConfirm}
//           confirmText={deleting ? t("common.deleting") : t("common.delete")}
//           confirmColor="danger"
//           confirmDisabled={deleting}
//         >
//           <div className="delete-confirmation">
//             <div className="warning-icon">⚠️</div>
//             <h3>{t("priceManager.confirmDeleteMessage")}</h3>
//             <div className="item-details">
//               <p>
//                 <strong>{t("priceManager.packageName")}:</strong>{" "}
//                 {packageToDelete.name}
//               </p>
//               <p>
//                 <strong>{t("priceManager.packageType")}:</strong>{" "}
//                 {getPackageTypeLabel(packageToDelete.package_type)}
//               </p>
//               <p>
//                 <strong>{t("priceManager.duration")}:</strong>{" "}
//                 {getDurationLabel(packageToDelete.duration)}
//               </p>
//               <p>
//                 <strong>{t("priceManager.basePrice")}:</strong>{" "}
//                 {formatCurrency(
//                   packageToDelete.base_price,
//                   packageToDelete.currency,
//                 )}
//               </p>
//               <p>
//                 <strong>{t("priceManager.currentPrice")}:</strong>{" "}
//                 {formatCurrency(
//                   getCurrentPrice(packageToDelete),
//                   packageToDelete.currency,
//                 )}
//               </p>
//               <p>
//                 <strong>{t("common.status")}:</strong>{" "}
//                 {packageToDelete.is_active
//                   ? t("common.active")
//                   : t("common.inactive")}
//               </p>
//             </div>
//             <p className="warning-text">{t("priceManager.deleteWarning")}</p>
//             <p className="warning-note">
//               <strong>{t("common.note")}:</strong>{" "}
//               {t("priceManager.deleteNote")}
//             </p>
//           </div>
//         </Modal>
//       )}
//     </>
//   );
// };

// export default SubscriptionPriceManager;

import React, { useState, useEffect } from "react";
import {
  Card,
  Table,
  Input,
  Button,
  Space,
  Tag,
  Tooltip,
  Select,
  Form,
} from "antd";
import {
  EyeOutlined,
  EditOutlined,
  DeleteOutlined,
  PoweroffOutlined,
  PlusOutlined,
  MinusCircleOutlined,
} from "@ant-design/icons";
import Modal from "../../components/Modal";
import { useGet, usePost, useDynamicApi } from "../../hooks/useApi";
import { useDebounce } from "../../hooks/useDebounce";
import { API_ENDPOINTS } from "../../config/api";
import Toast from "../../utils/toast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SubscriptionPriceManager = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [packageToDelete, setPackageToDelete] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // State for form data
  const [formData, setFormData] = useState({
    name: "",
    package_type: "INDIVIDUAL",
    duration: "SEASONAL",
    base_price: "",
    discounted_price: "",
    currency: "EUR",
    effective_start: "",
    effective_end: "",
    is_active: true,
    coach_price: "",
  });

  // Seasonal prices state
  const [seasonalPrices, setSeasonalPrices] = useState([]);

  // Form validation errors
  const [formErrors, setFormErrors] = useState({});

  // Pagination, search and filter states
  const [searchTerm, setSearchTerm] = useState("");
  const [packageTypeFilter, setPackageTypeFilter] = useState("");
  const [durationFilter, setDurationFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [packageList, setPackageList] = useState([]);

  // Options as per FRS and your model
  const PACKAGE_TYPE_OPTIONS = [
    { value: "INDIVIDUAL", label: t("priceManager.packageTypeIndividual") },
    { value: "CLUB", label: t("priceManager.packageTypeClub") },
    { value: "KNKV", label: t("priceManager.packageTypeKNKV") },
  ];

  const DURATION_OPTIONS = [
    { value: "MONTHLY", label: t("priceManager.durationMonthly") },
    { value: "QUARTERLY", label: t("priceManager.durationQuarterly") },
    { value: "YEARLY", label: t("priceManager.durationYearly") },
    { value: "SEASONAL", label: t("priceManager.durationSeasonal") },
  ];

  const CURRENCY_OPTIONS = [
    { value: "EUR", label: t("priceManager.currencyEUR") },
    { value: "USD", label: t("priceManager.currencyUSD") },
    { value: "INR", label: t("priceManager.currencyINR") },
  ];

  const STATUS_OPTIONS = [
    { value: "active", label: t("common.active") },
    { value: "inactive", label: t("common.inactive") },
  ];

  // API hooks
  const { execute: fetchList, loading: loadingList } = useGet(
    `${API_ENDPOINTS.PRICE_SUBSCRIPTION_LIST}?page=${currentPage}&page_size=${pageSize}&search=${debouncedSearchTerm}&package_type=${packageTypeFilter || ""}&duration=${durationFilter || ""}&status=${statusFilter || ""}`,
  );
  const { post, loading: creating } = usePost(
    API_ENDPOINTS.PRICE_SUBSCRIPTION_LIST,
  );
  const { execute: getById } = useDynamicApi("GET");
  const { execute: putData } = useDynamicApi("PUT");
  const { execute: patchData, loading: updatingStatus } =
    useDynamicApi("PATCH");
  const { execute: deleteData, loading: deleting } = useDynamicApi("DELETE");

  const loading =
    loadingList || creating || updatingStatus || deleting || submitting;

  // Load data
  const loadData = async () => {
    try {
      const response = await fetchList();
      if (response) {
        setPackageList(response.data || []);
        setTotalPages(response.pagination?.total_pages || 1);
        setTotalCount(response.pagination?.total_count || 0);
      }
    } catch (error) {
      console.error("Error loading data:", error);
    }
  };

  useEffect(() => {
    loadData();
  }, [currentPage, pageSize]);

  useEffect(() => {
    setCurrentPage(1);
    loadData();
  }, [debouncedSearchTerm, packageTypeFilter, durationFilter, statusFilter]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (formErrors[name]) {
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const handleNumberInput = (e) => {
    const { name, value } = e.target;
    if (value === "" || /^\d*\.?\d*$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      if (formErrors[name]) {
        setFormErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[name];
          return newErrors;
        });
      }
    }
  };

  // Seasonal prices handlers
  const addSeasonalPrice = () => {
    setSeasonalPrices([
      ...seasonalPrices,
      { start_month: "", end_month: "", price: "", is_active: true },
    ]);
  };

  const removeSeasonalPrice = (index) => {
    const newPrices = [...seasonalPrices];
    newPrices.splice(index, 1);
    setSeasonalPrices(newPrices);
    if (formErrors.seasonal_prices) {
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.seasonal_prices;
        return newErrors;
      });
    }
  };

  const updateSeasonalPrice = (index, field, value) => {
    const updated = [...seasonalPrices];
    updated[index][field] = value;
    setSeasonalPrices(updated);
    if (formErrors.seasonal_prices) {
      setFormErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors.seasonal_prices;
        return newErrors;
      });
    }
  };

  // Reset form
  const resetForm = () => {
    setFormData({
      name: "",
      package_type: "INDIVIDUAL",
      duration: "SEASONAL",
      base_price: "",
      discounted_price: "",
      currency: "EUR",
      effective_start: "",
      effective_end: "",
      is_active: true,
      coach_price: "",
    });
    setSeasonalPrices([]);
    setFormErrors({});
    setSelectedPackage(null);
    setIsEditMode(false);
  };

  // Reset filters
  const resetFilters = () => {
    setSearchTerm("");
    setPackageTypeFilter("");
    setDurationFilter("");
    setStatusFilter("");
  };
  // Add these functions inside the component, for example after resetForm or before validateForm

  const handlePackageTypeChange = (value) => {
    // If package type is not CLUB, set coach_price to 0
    if (value !== "CLUB") {
      setFormData((prev) => ({ ...prev, coach_price: "0" }));
    }
  };

  const handleDurationChange = (value) => {
    // If duration is not SEASONAL, clear seasonal prices
    if (value !== "SEASONAL") {
      setSeasonalPrices([]);
      // Also clear any seasonal_prices errors
      if (formErrors.seasonal_prices) {
        setFormErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors.seasonal_prices;
          return newErrors;
        });
      }
    }
  };
  // Validate form
  const validateForm = () => {
    const errors = {};

    if (!formData.name.trim()) {
      errors.name = t("priceManager.nameRequired");
    } else if (formData.name.trim().length < 2) {
      errors.name = t("priceManager.nameMinLength");
    } else if (formData.name.trim().length > 100) {
      errors.name = t("priceManager.nameMaxLength");
    }

    if (!formData.base_price.trim()) {
      errors.base_price = t("priceManager.basePriceRequired");
    } else {
      const basePrice = parseFloat(formData.base_price);
      if (isNaN(basePrice) || basePrice <= 0) {
        errors.base_price = t("priceManager.basePricePositive");
      }
    }

    if (formData.discounted_price.trim()) {
      const discountedPrice = parseFloat(formData.discounted_price);
      const basePrice = parseFloat(formData.base_price);
      if (isNaN(discountedPrice) || discountedPrice <= 0) {
        errors.discounted_price = t("priceManager.discountedPricePositive");
      } else if (discountedPrice > basePrice) {
        errors.discounted_price = t("priceManager.discountedPriceLessThanBase");
      }
    }

    if (formData.effective_start && formData.effective_end) {
      const startDate = new Date(formData.effective_start);
      const endDate = new Date(formData.effective_end);
      if (endDate < startDate) {
        errors.effective_end = t("priceManager.endDateAfterStart");
      }
    }

    // Coach price validation (only for CLUB)
    if (formData.package_type === "CLUB") {
      if (!formData.coach_price && formData.coach_price !== 0) {
        errors.coach_price = t("priceManager.coachPriceRequired");
      } else {
        const coachPrice = parseFloat(formData.coach_price);
        if (isNaN(coachPrice) || coachPrice < 0) {
          errors.coach_price = t("priceManager.coachPricePositive");
        }
      }
    }

    // Seasonal prices validation
    if (formData.duration === "SEASONAL") {
      if (seasonalPrices.length === 0) {
        errors.seasonal_prices = t("priceManager.seasonalPricesRequired");
      } else {
        for (let i = 0; i < seasonalPrices.length; i++) {
          const sp = seasonalPrices[i];
          if (!sp.start_month || !sp.end_month || !sp.price) {
            errors.seasonal_prices = t("priceManager.seasonalPricesIncomplete");
            break;
          }
          if (
            sp.start_month < 1 ||
            sp.start_month > 12 ||
            sp.end_month < 1 ||
            sp.end_month > 12
          ) {
            errors.seasonal_prices = t("priceManager.invalidMonthRange");
            break;
          }
          if (parseFloat(sp.price) <= 0) {
            errors.seasonal_prices = t("priceManager.seasonalPricePositive");
            break;
          }
        }
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // Handle create
  const handleCreate = async (e) => {
    e?.preventDefault?.();
    if (!validateForm()) return;

    setSubmitting(true);
    const payload = {
      ...formData,
      base_price: parseFloat(formData.base_price),
      discounted_price: formData.discounted_price
        ? parseFloat(formData.discounted_price)
        : null,
      coach_price: parseFloat(formData.coach_price || 0),
      seasonal_prices: formData.duration === "SEASONAL" ? seasonalPrices : [],
    };

    try {
      const response = await post(payload);
      if (response?.status === true) {
        Toast.success(response?.message || t("priceManager.createdSuccess"));
        await loadData();
        setIsModalOpen(false);
        resetForm();
      } else {
        if (response?.errors) setFormErrors(response.errors);
        else Toast.error(response?.message || t("priceManager.failedCreate"));
      }
    } catch (error) {
      console.error(error);
      Toast.error(error?.message || t("common.error"));
    } finally {
      setSubmitting(false);
    }
  };

  // Handle update
  const handleUpdate = async (e) => {
    e?.preventDefault?.();
    if (!selectedPackage?.id) {
      Toast.error(t("priceManager.idNotFound"));
      return;
    }
    if (!validateForm()) return;

    setSubmitting(true);
    const payload = {
      ...formData,
      base_price: parseFloat(formData.base_price),
      discounted_price: formData.discounted_price
        ? parseFloat(formData.discounted_price)
        : null,
      coach_price: parseFloat(formData.coach_price || 0),
      seasonal_prices: formData.duration === "SEASONAL" ? seasonalPrices : [],
    };

    try {
      const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${selectedPackage.id}`;
      const response = await putData(endpoint, payload);
      if (response?.status === true) {
        Toast.success(response?.message || t("priceManager.updatedSuccess"));
        await loadData();
        setIsModalOpen(false);
        resetForm();
      } else {
        if (response?.errors) setFormErrors(response.errors);
        else Toast.error(response?.message || t("priceManager.failedUpdate"));
      }
    } catch (error) {
      console.error(error);
      Toast.error(error?.message || t("common.error"));
    } finally {
      setSubmitting(false);
    }
  };

  // Toggle active status
  const handleToggleActive = async (item) => {
    try {
      const newStatus = !item.is_active;
      const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${item.id}`;
      const response = await patchData(endpoint, { is_active: newStatus });
      if (response?.status === true) {
        Toast.success(
          response?.message ||
            (newStatus ? t("common.active") : t("common.inactive")),
        );
        await loadData();
      } else {
        Toast.error(response?.message || t("attackManager.failedUpdateStatus"));
      }
    } catch (error) {
      console.error(error);
      Toast.error(error.message || t("attackManager.failedUpdateStatus"));
    }
  };

  // Delete
  const openDeleteModal = (item) => {
    setPackageToDelete(item);
    setIsDeleteModalOpen(true);
  };

  const handleDeleteConfirm = async () => {
    if (!packageToDelete) return;
    try {
      const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${packageToDelete.id}`;
      const response = await deleteData(endpoint);
      if (response?.status === true) {
        Toast.success(response?.message || t("priceManager.deletedSuccess"));
        await loadData();
      } else {
        Toast.error(response?.message || t("priceManager.failedDelete"));
      }
    } catch (error) {
      console.error(error);
      Toast.error(error.message || t("priceManager.failedDelete"));
    } finally {
      setIsDeleteModalOpen(false);
      setPackageToDelete(null);
    }
  };

  // Open create modal
  const openCreateModal = () => {
    resetForm();
    setIsEditMode(false);
    setIsModalOpen(true);
  };

  // Fetch package by ID for edit
  const fetchPackageById = async (id) => {
    const endpoint = `${API_ENDPOINTS.PRICE_SUBSCRIPTION_UPDATE}/${id}`;
    return await getById(endpoint);
  };

  // Open edit modal
  const openEditModal = async (item) => {
    try {
      const response = await fetchPackageById(item.id);
      if (response?.status === true && response.data) {
        const pkg = response.data;
        setSelectedPackage(pkg);
        setFormData({
          name: pkg.name || "",
          package_type: pkg.package_type || "INDIVIDUAL",
          duration: pkg.duration || "SEASONAL",
          base_price: pkg.base_price ? pkg.base_price.toString() : "",
          discounted_price: pkg.discounted_price
            ? pkg.discounted_price.toString()
            : "",
          currency: pkg.currency || "EUR",
          effective_start: pkg.effective_start || "",
          effective_end: pkg.effective_end || "",
          is_active: pkg.is_active !== undefined ? pkg.is_active : true,
          coach_price: pkg.coach_price ? pkg.coach_price.toString() : "0",
        });
        // Set seasonal prices if present
        if (pkg.seasonal_prices && Array.isArray(pkg.seasonal_prices)) {
          setSeasonalPrices(pkg.seasonal_prices);
        } else {
          setSeasonalPrices([]);
        }
        setFormErrors({});
        setIsEditMode(true);
        setIsModalOpen(true);
      } else {
        Toast.error(t("priceManager.failedFetchDetails"));
      }
    } catch (error) {
      console.error(error);
      Toast.error(error.message || t("priceManager.failedFetchDetails"));
    }
  };

  const openViewPage = (id) => {
    navigate(`/subscription-prices/details/${id}`);
  };

  // Helper display functions
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleDateString(i18n.language === "nl" ? "nl-NL" : "en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  const formatCurrency = (amount, currency) => {
    if (!amount || isNaN(amount)) return "N/A";
    const symbols = { EUR: "€", USD: "$", INR: "₹" };
    const symbol = symbols[currency] || currency;
    return `${symbol}${parseFloat(amount).toFixed(2)}`;
  };

  const getPackageTypeLabel = (type) => {
    const option = PACKAGE_TYPE_OPTIONS.find((opt) => opt.value === type);
    return option ? option.label : type;
  };

  const getDurationLabel = (duration) => {
    const option = DURATION_OPTIONS.find((opt) => opt.value === duration);
    return option ? option.label : duration;
  };

  const getCurrentPrice = (item) => {
    return item.discounted_price ? item.discounted_price : item.base_price;
  };

  const isPriceEffective = (item) => {
    if (!item.effective_start && !item.effective_end) return true;
    const today = new Date();
    const startDate = item.effective_start
      ? new Date(item.effective_start)
      : null;
    const endDate = item.effective_end ? new Date(item.effective_end) : null;
    if (startDate && today < startDate) return false;
    if (endDate && today > endDate) return false;
    return true;
  };

  const hasFilters =
    searchTerm || packageTypeFilter || durationFilter || statusFilter;

  const columns = [
    {
      title: t("priceManager.packageName"),
      dataIndex: "name",
      key: "name",
      render: (name, item) => (
        <>
          <strong>{name || "N/A"}</strong>
          {!isPriceEffective(item) && (
            <div>
              <small style={{ color: "orange" }}>
                ⏱️ {t("priceManager.pricePending")}
              </small>
            </div>
          )}
        </>
      ),
    },
    {
      title: t("priceManager.packageType"),
      dataIndex: "package_type",
      key: "package_type",
      render: (type) => getPackageTypeLabel(type),
    },
    {
      title: t("priceManager.duration"),
      dataIndex: "duration",
      key: "duration",
      render: (duration) => getDurationLabel(duration),
    },
    {
      title: t("priceManager.basePrice"),
      key: "base_price",
      render: (_, record) => formatCurrency(record.base_price, record.currency),
    },
    {
      title: t("priceManager.currentPrice"),
      key: "current_price",
      render: (_, record) => (
        <strong style={{ color: "#1890ff" }}>
          {formatCurrency(getCurrentPrice(record), record.currency)}
        </strong>
      ),
    },
    {
      title: t("priceManager.subscriptionDates"),
      key: "effective",
      render: (_, record) =>
        record.effective_start ? (
          <div>
            <div>{formatDate(record.effective_start)}</div>
            <div>
              {t("common.to")} {formatDate(record.effective_end) || "∞"}
            </div>
          </div>
        ) : (
          t("priceManager.always")
        ),
    },
    {
      title: t("common.status"),
      dataIndex: "is_active",
      key: "status",
      render: (active) => (
        <Tag color={active ? "green" : "default"}>
          {active ? t("common.active") : t("common.inactive")}
        </Tag>
      ),
    },
    {
      title: t("common.actions"),
      key: "actions",
      width: 200,
      render: (_, record) => (
        <Space>
          <Tooltip
            title={record.is_active ? t("common.inactive") : t("common.active")}
          >
            <Button
              size="small"
              danger={record.is_active}
              type={record.is_active ? "default" : "primary"}
              icon={<PoweroffOutlined />}
              onClick={() => handleToggleActive(record)}
              disabled={updatingStatus}
            />
          </Tooltip>
          <Tooltip title={t("common.view")}>
            <Button
              type="primary"
              size="small"
              icon={<EyeOutlined />}
              onClick={() => openViewPage(record.id)}
            />
          </Tooltip>
          <Tooltip title={t("common.edit")}>
            <Button
              type="primary"
              size="small"
              style={{ background: "#52c41a", borderColor: "#52c41a" }}
              icon={<EditOutlined />}
              onClick={() => openEditModal(record)}
            />
          </Tooltip>
          <Tooltip title={t("common.delete")}>
            <Button
              danger
              size="small"
              icon={<DeleteOutlined />}
              onClick={() => openDeleteModal(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Card
        title={t("priceManager.title")}
        extra={
          <Button type="primary" onClick={openCreateModal} disabled={loading}>
            {t("priceManager.createNew")}
          </Button>
        }
      >
        <div
          style={{
            display: "flex",
            gap: "16px",
            marginBottom: 16,
            flexWrap: "wrap",
          }}
        >
          <Input
            placeholder={t("priceManager.searchPlaceholder")}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            allowClear
            style={{ width: 280 }}
            disabled={loading}
          />
          <Select
            placeholder={t("priceManager.packageType")}
            value={packageTypeFilter || undefined}
            onChange={(v) => setPackageTypeFilter(v || "")}
            style={{ width: 160 }}
            allowClear
            options={PACKAGE_TYPE_OPTIONS}
            disabled={loading}
          />
          <Select
            placeholder={t("priceManager.duration")}
            value={durationFilter || undefined}
            onChange={(v) => setDurationFilter(v || "")}
            style={{ width: 160 }}
            allowClear
            options={DURATION_OPTIONS}
            disabled={loading}
          />
          <Select
            placeholder={t("common.filterByStatus")}
            value={statusFilter || undefined}
            onChange={(v) => setStatusFilter(v || "")}
            style={{ width: 140 }}
            allowClear
            options={STATUS_OPTIONS}
            disabled={loading}
          />
          {hasFilters && (
            <Button onClick={resetFilters} disabled={loading}>
              {t("common.clearFilters")}
            </Button>
          )}
        </div>

        <div className="table-responsive">
          <Table
            dataSource={packageList}
            columns={columns}
            rowKey="id"
            loading={loading}
            locale={{
              emptyText: hasFilters
                ? t("priceManager.noMatchingPackages")
                : t("priceManager.noPricesFound"),
            }}
            pagination={{
              current: currentPage,
              pageSize,
              total: totalCount,
              showSizeChanger: true,
              pageSizeOptions: ["5", "10", "20", "50", "100"],
              showTotal: (total) =>
                `${t("common.showing")} ${(currentPage - 1) * pageSize + 1} ${t("common.to")} ${Math.min(
                  currentPage * pageSize,
                  total,
                )} ${t("common.of")} ${total} ${t("priceManager.packages")}`,
              onChange: (page, size) => {
                setCurrentPage(page);
                setPageSize(size || 10);
              },
            }}
          />
        </div>
      </Card>

      {/* Create/Edit Modal */}
      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            resetForm();
          }}
          title={
            isEditMode
              ? t("priceManager.editTitle")
              : t("priceManager.createTitle")
          }
          onConfirm={isEditMode ? handleUpdate : handleCreate}
          confirmText={
            isEditMode
              ? submitting
                ? t("priceManager.updating")
                : t("common.update")
              : submitting
                ? t("priceManager.creating")
                : t("common.create")
          }
          showConfirm={true}
          size="large"
          confirmDisabled={submitting}
        >
          <form onSubmit={isEditMode ? handleUpdate : handleCreate}>
            {/* Row 1: Name and Package Type */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
                marginBottom: "16px",
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.packageName")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  placeholder={t("priceManager.enterPackageName")}
                  disabled={submitting}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: formErrors.name
                      ? "1px solid #dc3545"
                      : "1px solid #d9d9d9",
                    borderRadius: "4px",
                  }}
                  maxLength={100}
                />
                <div
                  style={{
                    fontSize: "12px",
                    color: "#666",
                    textAlign: "right",
                    marginTop: "4px",
                  }}
                >
                  {formData.name.length}/100
                </div>
                {formErrors.name && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formErrors.name}
                  </div>
                )}
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.packageType")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  name="package_type"
                  value={formData.package_type}
                  onChange={(e) => {
                    handleInputChange(e);
                    handlePackageTypeChange(e.target.value);
                  }}
                  disabled={submitting}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "4px",
                  }}
                >
                  <option value="">
                    {t("priceManager.selectPackageType")}
                  </option>
                  {PACKAGE_TYPE_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 2: Duration and Currency */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
                marginBottom: "16px",
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.duration")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  name="duration"
                  value={formData.duration}
                  onChange={(e) => {
                    handleInputChange(e);
                    handleDurationChange(e.target.value);
                  }}
                  disabled={submitting}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "4px",
                  }}
                >
                  <option value="">{t("priceManager.selectDuration")}</option>
                  {DURATION_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.currency")}
                </label>
                <select
                  name="currency"
                  value={formData.currency}
                  onChange={handleInputChange}
                  disabled={submitting}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "4px",
                  }}
                >
                  {CURRENCY_OPTIONS.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 3: Base Price and Discounted Price */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
                marginBottom: "16px",
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.basePrice")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px", fontSize: "16px" }}>
                    {formData.currency === "EUR"
                      ? "€"
                      : formData.currency === "USD"
                        ? "$"
                        : "₹"}
                  </span>
                  <input
                    type="text"
                    name="base_price"
                    value={formData.base_price}
                    onChange={handleNumberInput}
                    placeholder="0.00"
                    disabled={submitting}
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      border: formErrors.base_price
                        ? "1px solid #dc3545"
                        : "1px solid #d9d9d9",
                      borderRadius: "4px",
                    }}
                  />
                </div>
                {formErrors.base_price && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formErrors.base_price}
                  </div>
                )}
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.discountedPrice")}
                </label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px", fontSize: "16px" }}>
                    {formData.currency === "EUR"
                      ? "€"
                      : formData.currency === "USD"
                        ? "$"
                        : "₹"}
                  </span>
                  <input
                    type="text"
                    name="discounted_price"
                    value={formData.discounted_price}
                    onChange={handleNumberInput}
                    placeholder="0.00"
                    disabled={submitting}
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      border: formErrors.discounted_price
                        ? "1px solid #dc3545"
                        : "1px solid #d9d9d9",
                      borderRadius: "4px",
                    }}
                  />
                </div>
                {formErrors.discounted_price && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formErrors.discounted_price}
                  </div>
                )}
              </div>
            </div>

            {/* Coach Price - only for CLUB */}
            {formData.package_type === "CLUB" && (
              <div style={{ marginBottom: "16px" }}>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.coachPrice")}{" "}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={{ marginRight: "8px", fontSize: "16px" }}>
                    {formData.currency === "EUR"
                      ? "€"
                      : formData.currency === "USD"
                        ? "$"
                        : "₹"}
                  </span>
                  <input
                    type="text"
                    name="coach_price"
                    value={formData.coach_price}
                    onChange={handleNumberInput}
                    placeholder="0.00"
                    disabled={submitting}
                    style={{
                      flex: 1,
                      padding: "8px 12px",
                      border: formErrors.coach_price
                        ? "1px solid #dc3545"
                        : "1px solid #d9d9d9",
                      borderRadius: "4px",
                    }}
                  />
                </div>
                {formErrors.coach_price && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formErrors.coach_price}
                  </div>
                )}
              </div>
            )}

            {/* Seasonal Prices - only for SEASONAL duration */}
            {/* {formData.duration === "SEASONAL" && (
              <div
                style={{
                  marginBottom: "16px",
                  border: "1px solid #e8e8e8",
                  padding: "16px",
                  borderRadius: "4px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <label style={{ fontWeight: "500" }}>
                    {t("priceManager.seasonalPrices")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Button
                    type="dashed"
                    onClick={addSeasonalPrice}
                    icon={<PlusOutlined />}
                    size="small"
                  >
                    {t("priceManager.addSeasonalPrice")}
                  </Button>
                </div>
                {formErrors.seasonal_prices && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginBottom: "12px",
                    }}
                  >
                    {formErrors.seasonal_prices}
                  </div>
                )}
                {seasonalPrices.map((sp, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      gap: "12px",
                      marginBottom: "12px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <input
                        type="number"
                        placeholder={t("priceManager.startMonth")}
                        value={sp.start_month}
                        onChange={(e) =>
                          updateSeasonalPrice(
                            index,
                            "start_month",
                            parseInt(e.target.value) || "",
                          )
                        }
                        min="1"
                        max="12"
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          borderRadius: "4px",
                          border: "1px solid #d9d9d9",
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <input
                        type="number"
                        placeholder={t("priceManager.endMonth")}
                        value={sp.end_month}
                        onChange={(e) =>
                          updateSeasonalPrice(
                            index,
                            "end_month",
                            parseInt(e.target.value) || "",
                          )
                        }
                        min="1"
                        max="12"
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          borderRadius: "4px",
                          border: "1px solid #d9d9d9",
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span style={{ marginRight: "6px" }}>
                          {formData.currency === "EUR"
                            ? "€"
                            : formData.currency === "USD"
                              ? "$"
                              : "₹"}
                        </span>
                        <input
                          type="number"
                          step="0.01"
                          placeholder={t("priceManager.price")}
                          value={sp.price}
                          onChange={(e) =>
                            updateSeasonalPrice(
                              index,
                              "price",
                              parseFloat(e.target.value) || "",
                            )
                          }
                          style={{
                            width: "100%",
                            padding: "6px 10px",
                            borderRadius: "4px",
                            border: "1px solid #d9d9d9",
                          }}
                        />
                      </div>
                    </div>
                    <Button
                      type="text"
                      danger
                      icon={<MinusCircleOutlined />}
                      onClick={() => removeSeasonalPrice(index)}
                      disabled={seasonalPrices.length === 1}
                    />
                  </div>
                ))}
                <div
                  style={{ fontSize: "12px", color: "#888", marginTop: "8px" }}
                >
                  {t("priceManager.seasonalPricesHint")}
                </div>
              </div>
            )} */}
            {formData.duration === "SEASONAL" && (
              <div
                style={{
                  marginBottom: "16px",
                  border: "1px solid #e8e8e8",
                  padding: "16px",
                  borderRadius: "4px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <label style={{ fontWeight: "500" }}>
                    {t("priceManager.seasonalPrices")}{" "}
                    <span style={{ color: "red" }}>*</span>
                  </label>
                  <Button
                    type="dashed"
                    onClick={addSeasonalPrice}
                    icon={<PlusOutlined />}
                    size="small"
                  >
                    {t("priceManager.addSeasonalPrice")}
                  </Button>
                </div>

                {formErrors.seasonal_prices && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginBottom: "12px",
                    }}
                  >
                    {formErrors.seasonal_prices}
                  </div>
                )}

                {/* Table headers */}
                <div
                  style={{
                    display: "flex",
                    gap: "12px",
                    marginBottom: "8px",
                    fontWeight: "bold",
                    fontSize: "13px",
                  }}
                >
                  <div style={{ flex: 1 }}>{t("priceManager.startMonth")}</div>
                  <div style={{ flex: 1 }}>{t("priceManager.endMonth")}</div>
                  <div style={{ flex: 1 }}>{t("priceManager.price")}</div>
                  <div style={{ width: "32px" }}></div>{" "}
                  {/* placeholder for remove button */}
                </div>

                {/* Seasonal price rows */}
                {seasonalPrices.map((sp, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      gap: "12px",
                      marginBottom: "12px",
                      alignItems: "center",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <input
                        type="number"
                        placeholder="1‑12"
                        value={sp.start_month}
                        onChange={(e) =>
                          updateSeasonalPrice(
                            index,
                            "start_month",
                            parseInt(e.target.value) || "",
                          )
                        }
                        min="1"
                        max="12"
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          borderRadius: "4px",
                          border: "1px solid #d9d9d9",
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <input
                        type="number"
                        placeholder="1‑12"
                        value={sp.end_month}
                        onChange={(e) =>
                          updateSeasonalPrice(
                            index,
                            "end_month",
                            parseInt(e.target.value) || "",
                          )
                        }
                        min="1"
                        max="12"
                        style={{
                          width: "100%",
                          padding: "6px 10px",
                          borderRadius: "4px",
                          border: "1px solid #d9d9d9",
                        }}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <span style={{ marginRight: "6px" }}>
                          {formData.currency === "EUR"
                            ? "€"
                            : formData.currency === "USD"
                              ? "$"
                              : "₹"}
                        </span>
                        <input
                          type="number"
                          step="0.01"
                          placeholder="0.00"
                          value={sp.price}
                          onChange={(e) =>
                            updateSeasonalPrice(
                              index,
                              "price",
                              parseFloat(e.target.value) || "",
                            )
                          }
                          style={{
                            width: "100%",
                            padding: "6px 10px",
                            borderRadius: "4px",
                            border: "1px solid #d9d9d9",
                          }}
                        />
                      </div>
                    </div>
                    <Button
                      type="text"
                      danger
                      icon={<MinusCircleOutlined />}
                      onClick={() => removeSeasonalPrice(index)}
                      disabled={seasonalPrices.length === 1}
                      style={{ width: "32px" }}
                    />
                  </div>
                ))}

                <div
                  style={{ fontSize: "12px", color: "#888", marginTop: "8px" }}
                >
                  {t("priceManager.seasonalPricesHint")}
                </div>
              </div>
            )}

            {/* Date fields */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
                marginBottom: "16px",
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.effectiveStart")}
                </label>
                <input
                  type="date"
                  name="effective_start"
                  value={formData.effective_start}
                  onChange={handleInputChange}
                  disabled={submitting}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "4px",
                  }}
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "500",
                  }}
                >
                  {t("priceManager.effectiveEnd")}
                </label>
                <input
                  type="date"
                  name="effective_end"
                  value={formData.effective_end}
                  onChange={handleInputChange}
                  disabled={submitting}
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "1px solid #d9d9d9",
                    borderRadius: "4px",
                  }}
                />
                {formErrors.effective_end && (
                  <div
                    style={{
                      color: "#dc3545",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {formErrors.effective_end}
                  </div>
                )}
              </div>
            </div>

            {/* Active checkbox */}
            <div style={{ marginBottom: "16px" }}>
              <label
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <input
                  type="checkbox"
                  name="is_active"
                  checked={formData.is_active}
                  onChange={handleInputChange}
                  disabled={submitting}
                />
                <span style={{ fontWeight: "500" }}>
                  {t("priceManager.activePackage")}
                </span>
              </label>
            </div>
          </form>
        </Modal>
      )}

      {/* Delete Confirmation Modal */}
      {isDeleteModalOpen && packageToDelete && (
        <Modal
          isOpen={isDeleteModalOpen}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setPackageToDelete(null);
          }}
          title={t("priceManager.confirmDelete")}
          onConfirm={handleDeleteConfirm}
          confirmText={deleting ? t("common.deleting") : t("common.delete")}
          confirmColor="danger"
          confirmDisabled={deleting}
        >
          <div className="delete-confirmation">
            <div className="warning-icon">⚠️</div>
            <h3>{t("priceManager.confirmDeleteMessage")}</h3>
            <div className="item-details">
              <p>
                <strong>{t("priceManager.packageName")}:</strong>{" "}
                {packageToDelete.name}
              </p>
              <p>
                <strong>{t("priceManager.packageType")}:</strong>{" "}
                {getPackageTypeLabel(packageToDelete.package_type)}
              </p>
              <p>
                <strong>{t("priceManager.duration")}:</strong>{" "}
                {getDurationLabel(packageToDelete.duration)}
              </p>
              <p>
                <strong>{t("priceManager.basePrice")}:</strong>{" "}
                {formatCurrency(
                  packageToDelete.base_price,
                  packageToDelete.currency,
                )}
              </p>
              <p>
                <strong>{t("priceManager.currentPrice")}:</strong>{" "}
                {formatCurrency(
                  getCurrentPrice(packageToDelete),
                  packageToDelete.currency,
                )}
              </p>
              <p>
                <strong>{t("common.status")}:</strong>{" "}
                {packageToDelete.is_active
                  ? t("common.active")
                  : t("common.inactive")}
              </p>
            </div>
            <p className="warning-text">{t("priceManager.deleteWarning")}</p>
            <p className="warning-note">
              <strong>{t("common.note")}:</strong>{" "}
              {t("priceManager.deleteNote")}
            </p>
          </div>
        </Modal>
      )}
    </>
  );
};

export default SubscriptionPriceManager;
